import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {TemplateMessageEndpointContainerModel} from "../../../../../../../models/aggregates/alg/cc/template-message";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class TemplateMessageEndpointService extends BaseApiTemplateService<TemplateMessageEndpointContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'template-message-endpoint-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'template-message-endpoint-links';
    this.httpClient = http;
  }
}
